module.exports = __webpack_public_path__ + "img/coin-lock.9e93ff5f.png";